// extracted by mini-css-extract-plugin
export var csatScore = "_fp-5";
export var header = "_fp-1";
export var panelWrapper = "_fp-2";
export var postPreview = "_fp-3";
export var rightContent = "_fp-0";
export var wrappingText = "_fp-4";